export var DEFAULT_TEXT = 'Me ajude a escolher a melhor promoção, Lu';
export var LU_WHATSAPP_NUMBER = '5511974627106';